(function () {
    'use strict';
    /*
     * Copyright (c) 2014-16 In Hand Health.
     * All rights reserved.
     */


    angular
        .module('ihh-common-web')
        .directive('rxExerciseTemplate', rxExerciseTemplate);

    rxExerciseTemplate.$inject = ['ResearchUtilities'];

    function rxExerciseTemplate(ResearchUtilities) {
        return {
            restrict: 'AE',
            scope: {
                /**
                 * Whether the item is being edited or not
                 *
                 * @ngdoc property
                 * @name is-edit
                 * @memberOf ihh-common-web.rxExerciseTemplate
                 */
                isEdit: '=',

                /**
                 * The sort listeners for the as-sortable directive.
                 *
                 * @ngdoc property
                 * @name sort-listeners
                 * @memberOf ihh-common-web.rxExerciseTemplate
                 */
                sortListeners: '=',

                /**
                 * The index of the parent ngRepeat, used for creating unique HTML id attributes.
                 *
                 * @ngdoc property
                 * @name parent-index
                 * @memberOf ihh-common-web.rxExerciseTemplate
                 */
                parentIndex: '=',

                /**
                 * The editable templates.
                 *
                 * @ngdoc property
                 * @name edit-exercise-templates
                 * @memberOf ihh-common-web.rxExerciseTemplate
                 */
                editExerciseTemplates: '=',

                /**
                 * The viewable templates.
                 *
                 * @ngdoc property
                 * @name view-exercise-templates
                 * @memberOf ihh-common-web.rxExerciseTemplate
                 */
                viewExerciseTemplates: '=',

                /**
                 * The prescription template which contains the templates.
                 *
                 * @ngdoc property
                 * @name prescription-template
                 * @memberOf ihh-common-web.rxExerciseTemplate
                 */
                prescriptionTemplate: '=',

                /**
                 * The containing form, used for accessing the dirty flag.
                 *
                 * @ngdoc property
                 * @name containing-form
                 * @memberOf ihh-common-web.rxExerciseTemplate
                 */
                containingForm: '=',

                /**
                 * The function for deleting an template.
                 *
                 * @ngdoc property
                 * @name delete-exercise-template
                 * @memberOf ihh-common-web.rxExerciseTemplate
                 */
                deleteExerciseTemplate: '=',

                /**
                 * The function for getting an exercise thumbnail url.
                 *
                 * @ngdoc property
                 * @name get-exercise-thumbnail-url
                 * @memberOf ihh-common-web.rxExerciseTemplate
                 */
                getExerciseThumbnailUrl: '=',

                /**
                 * The function for getting an exercise link url.
                 *
                 * @ngdoc property
                 * @name get-exercise-link-url
                 * @memberOf ihh-common-web.rxExerciseTemplate
                 */
                getExerciseLinkUrl: '=',

                /**
                 * The id prefix used to prefix all control-ids
                 *
                 * @ngdoc property
                 * @name id-prefix
                 * @memberOf ihh-common-web.rxExerciseTemplate
                 */
                idPrefix: '@'
            },
            templateUrl: 'rx-exercise-template/rx-exercise-template.tpl.html',
            link: function(scope /*, element, attributes*/ ) {
                scope.quantityTypes = ResearchUtilities.quantityTypes;
                scope.getQuantityType = ResearchUtilities.getQuantityType;
                scope.setQuantityType = ResearchUtilities.setQuantityType;
                scope.displayQuantityType = ResearchUtilities.displayQuantityType;
                scope.getResistanceItemValue = ResearchUtilities.getResistanceItemValue;
                scope.setResistanceItemValue = ResearchUtilities.setResistanceItemValue;
                scope.getControlId = ResearchUtilities.getControlId;

                if (!scope.idPrefix) {
                    scope.idPrefix = '';
                }

                scope.setTtsInstructions = function(exerciseTemplate) {
                    exerciseTemplate.ttsInstructions = true;
                };

                scope.setTtsCuesAndTips = function(exerciseTemplate) {
                    exerciseTemplate.ttsCuesAndTips = true;
                };

                scope.isEmptyDropzone = function() {
                    return scope.isEdit && (!scope.editExerciseTemplates || scope.editExerciseTemplates.length === 0);
                };
            }
        };
    }
})();